import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/posts',
    name: 'Posts',
    component: {
      name: 'AdminPost',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'post',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminPostIndex',
        component: () => import('../views/admin/PostAdminIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminPostNew',
        component: () => import('../views/admin/PostAdminInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminPostIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminPostShow',
        component: () => import('../views/admin/PostAdminShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminPostIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminPostDetails',
            component: () => import('../views/admin/PostAdminDetails.vue'),
            meta: {
              backRoute: { name: 'AdminPostIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminPostEdit',
            component: () => import('../views/admin/PostAdminInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminPostDetails' },
            },
          },
          {
            path: 'previews',
            name: 'AdminPostPreviews',
            component: () => import('../views/preview/PostPreviews.vue'),
            meta: {
              backRoute: { name: 'AdminPermitIndex' },
              resource: 'preview',
            },
          },
        ],
      },
    ]
  },
  {
    path: 'user/posts',
    name: 'UserPosts',
    component: {
      name: 'UserPost',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'post',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserPostIndex',
        component: () => import('../views/user/PostUserIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'UserPostDetails',
        component: () => import('../views/user/PostUserShow.vue'),
        meta: {
          backRoute: { name: 'UserPostIndex' },
        },
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));